import React, {useState} from 'react';
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Fab,
    Grid,
    IconButton,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TextField,
    Typography,
    withStyles
} from "@material-ui/core";
import {Add, Edit, Delete} from "@material-ui/icons";
import {appStyles} from "../../styles";
import FlightOptionsContext from "../Session/flightOptionsContext";
import {withFirebase} from "../Firebase";
import ConfirmDialog from "../Forms/ConfirmDialog";

const SortieEventForm = (props) => {
    const {open, handleClose, data, firebase, isAdding} = props;
    const [id, setId] = useState(data.id || '');
    const [name, setName] = useState(data.name);

    const handleSave = () => {
        const updatedData = {
            name,
        };
        if (isAdding) {
            firebase.sortieEvent(id).set(updatedData).then(() => handleClose());
        } else {
            firebase.sortieEvent(data.id).set(updatedData).then(() => handleClose());
        }
    };

    return (
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>{isAdding ? 'Add Sortie Event' : 'Edit Sortie Event'}</DialogTitle>
            <DialogContent>
                <Grid container spacing={2}>
                    {isAdding && <Grid item xs={12}>
                        <TextField id="sortie-event-type" label="Type" value={id} onChange={(e) => setId(e.target.value)} fullWidth/>
                    </Grid>}
                    <Grid item xs={12}>
                        <TextField id="sortie-event-name" label="Name" value={name} onChange={(e) => setName(e.target.value)} fullWidth/>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Cancel</Button>
                <Button onClick={handleSave} color="primary">Save</Button>
            </DialogActions>
        </Dialog>
    );
}

const SortieEventsSettings = (props) => {
    const {classes, firebase} = props;
    const flightOptions = React.useContext(FlightOptionsContext);
    const [open, setOpen] = useState(false);
    const [selected, setSelected] = useState(null);
    const [isAdding, setIsAdding] = useState(false);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [itemToDelete, setItemToDelete] = useState(null);

    const handleEdit = (id) => {
        setSelected({id, ...flightOptions.sortieEvents[id]});
        setOpen(true);
    };

    const handleAdd = () => {
        setSelected({
            name: '',
        });
        setIsAdding(true);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setSelected(null);
        setIsAdding(false);
    };

    const handleDelete = (id) => {
        setItemToDelete(id);
        setConfirmOpen(true);
    };

    const handleConfirmDelete = () => {
        if (itemToDelete) {
            firebase.sortieEvent(itemToDelete).delete().then(() => {
                setItemToDelete(null);
                setConfirmOpen(false);
            });
        }
    };

    if (!flightOptions.sortieEvents) {
        return null;
    }

    return (
        <Paper className={classes.paper}>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <Typography variant="h6">Sortie Events</Typography>
                <Fab className={`${classes.fab} ${classes.fabAdd}`}
                     color="secondary"
                     aria-label="add"
                     size={"small"}
                     onClick={handleAdd}
                >
                    <Add />
                </Fab>
            </Box>
            <Table className={classes.settingsTable}>
                <TableHead>
                    <TableRow>
                        <TableCell className={classes.settingsTableCell}>Type</TableCell>
                        <TableCell className={classes.settingsTableCell}>Name</TableCell>
                        <TableCell className={classes.settingsTableCell}></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {Object.keys(flightOptions.sortieEvents).map((keyName, keyIndex) => (
                        <TableRow key={keyIndex} className={classes.hoverRow}>
                            <TableCell className={classes.settingsTableCell}>{keyName}</TableCell>
                            <TableCell className={classes.settingsTableCell}>{flightOptions.sortieEvents[keyName].name}</TableCell>
                            <TableCell className={classes.settingsTableCell}>
                                <Box display="flex" justifyContent="flex-end">
                                    <IconButton aria-label="edit" onClick={() => handleEdit(keyName)}>
                                        <Edit />
                                    </IconButton>
                                    <IconButton aria-label="delete" onClick={() => handleDelete(keyName)}>
                                        <Delete />
                                    </IconButton>
                                </Box>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
            {selected && <SortieEventForm open={open} handleClose={handleClose} data={selected} isAdding={isAdding} firebase={firebase} {...props}/>}
            <ConfirmDialog open={confirmOpen}
                           title="Delete Sortie Event"
                           text="Are you sure you want to delete this sortie event? Removing this event type will cause existing sorties with this event to display incorrectly."
                           onCancel={() => setConfirmOpen(false)}
                           onConfirm={handleConfirmDelete}/>
        </Paper>
    );
};

export default withFirebase(withStyles(appStyles)(SortieEventsSettings));
